import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ageAnalysisPdfRes;
export const ageAnalysisPdfTodo = createAsyncThunk('ageAnalysisPdf', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'age_analytics',
            data: {
                // "vfrom_date": data?.fromDate,
                "vto_date": data?.toDate,
                "vsupplier_name": localStorage.getItem('vplant_name'),
                "vaccount_code": localStorage.getItem('vcust_plant_code'),
                "vmarketing_engineer_code": "",
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id')
            },
            headers: { "Content-Type": "application/json" },

        })
        return ageAnalysisPdfRes = res.data

    } catch (error) {
        return ageAnalysisPdfRes = error.response.data
    }
});

